export interface ProductConfig {
  enabled: boolean;
  displayOrder?: number;
  maintenanceMode?: boolean;
  availableFrom?: Date;
  availableUntil?: Date;
}

export const productConfiguration: Record<string, ProductConfig> = {
  'skyvision-fixed': {
    enabled: true,
    displayOrder: 1,
  },
  'skyvision-comfort': {
    enabled: true,
    displayOrder: 2,
  },
  'skyvision-circular': {
    enabled: true,
    displayOrder: 3,
  },
  'skyvision-walkon': {
    enabled: true,
    displayOrder: 4,
  },
  'skyvision-circular-walkon': {
    enabled: true,
    displayOrder: 5,
  },
  'skyvision-linear': {
    enabled: true,
    displayOrder: 6,
  },
  'skyvision-access': {
    enabled: true,
    displayOrder: 7,
  },
  'skyvision-linear-walkon': {
    enabled: true,
    displayOrder: 8,
  },
};

/**
 * Hilfsfunktion um zu prüfen ob ein Produkt verfügbar ist
 */
export const isProductEnabled = (productId: string): boolean => {
  const config = productConfiguration[productId];
  if (!config) return false;
  
  if (!config.enabled) return false;
  
  if (config.maintenanceMode) return false;
  
  const now = new Date();
  if (config.availableFrom && now < config.availableFrom) return false;
  if (config.availableUntil && now > config.availableUntil) return false;
  
  return true;
};

export const getProductDisplayOrder = (productId: string): number => {
  return productConfiguration[productId]?.displayOrder || 999;
};
